export default {"src":"/_next/static/media/23-icon.fbb3829a.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};